export const getStateName = (code, states) => {
  const state = states.find((state) => state.Code === code);
  return state ? state.State : code;
};

export const getCountryName = (code, countryCodes) => {
  const country = countryCodes.find((country) => country.Code === code);
  return country ? country.Country : code;
};

const sourceMapping = {
  api: 'API',
  web: 'WEB',
  sftp: 'Bulk Upload - SFTP',
  bulk_upload: 'Bulk Upload - WebApp',
};

export const transactionTypePositionCheck = (transactionType, position) => {
  // position is 1-based, so subtract 1 for 0-based index
  return transactionType && transactionType[position - 1] === '1';
};